import { render } from "./StepC.vue?vue&type=template&id=1a33c054"
import script from "./StepC.vue?vue&type=script&lang=js"
export * from "./StepC.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/signupLawyer/StepC.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a33c054"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a33c054', __exports__)) {
    api.reload('1a33c054', __exports__)
  }
  
  module.hot.accept("./StepC.vue?vue&type=template&id=1a33c054", () => {
    api.rerender('1a33c054', render)
  })

}


export default __exports__